import { useState } from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import ContactForm from '../components/ContactForm'
import { CONTACT_META } from '../data/meta'

const encodeEmail = (local, domain) => {
  const email = `${local}@${domain}`
  const labels = email.split('').map((c) => `&#${c.charCodeAt(0)};`).join('')
  return { mailto: email, label: labels }
}

const contactInfo = [
  {
    icon: 'fa-envelope',
    title: 'Email Us',
    detail: 'We respond within 24 hours',
    type: 'email',
    value: 'support@tredextechnology.in',
  },
  {
    icon: 'fa-building',
    title: 'Business Email',
    detail: 'For business inquiries and partnerships',
    type: 'business_email',
    value: 'business@tredextechnology.in',
  },
  {
    icon: 'fa-phone-alt',
    title: 'Call Us',
    detail: 'Mon–Fri, 9 AM – 7 PM IST',
    type: 'phone',
    value: '+91 9677255272',
    href: 'tel:+919677255272',
  },
  {
    icon: 'fa-map-marker-alt',
    title: 'Our HQ',
    detail: 'Chennai, Tamil Nadu, India',
    type: 'address',
    value: 'Chennai, Tamil Nadu, India',
  },
  {
    icon: 'fa-globe',
    title: 'Global Clients',
    detail: 'Serving clients worldwide since 2024',
    type: 'global',
    value: 'Worldwide',
  },
]

const FAQS = [
  {
    question: 'What is the best way to reach TRED-EX AI?',
    answer: 'You can email us at support@tredextechnology.in, call us at +91 9677255272, or fill out the contact form below. We respond to all inquiries within 24 hours during business days.'
  },
  {
    question: 'Do you offer free consultations?',
    answer: 'Yes, we provide a free, no-obligation AI audit of your website. During the audit, we identify quick wins and recommend the perfect AI features for your business. There is no commitment required.'
  },
  {
    question: 'How quickly can you start implementing AI features?',
    answer: 'Most features go live within 7-14 days. A simple AI chatbot can be installed in 3-5 days. Complex integrations like custom AI model training may take 2-4 weeks. We provide a detailed timeline during your free audit.'
  },
  {
    question: 'Do I need to rebuild my website to add AI features?',
    answer: 'No. We add AI features to your existing website using embed codes, APIs, and JavaScript widgets. Your current design, CMS, and hosting remain untouched.'
  },
  {
    question: 'Can you work with websites built on different platforms?',
    answer: 'Absolutely. We work with WordPress, Shopify, Wix, Squarespace, custom HTML, React, and if it has a URL, we can add AI to it. Tell us your setup and we will confirm compatibility.'
  },
]

export default function Contact() {
  const [openFaq, setOpenFaq] = useState(null)

  return (
    <>
      <SEO
        title={CONTACT_META.title}
        description={CONTACT_META.description}
        canonical={CONTACT_META.canonical}
        keywords={CONTACT_META.keywords}
        structuredData={CONTACT_META.structuredData}
      />
      <Navbar />
      <section className="contact-page">
         <div className="container">
          {/* Hero / Header */}
          <div className="section-header">
            <span className="section-badge">Contact Us</span>
            <h1 className="page-title">Let's Discuss Your <span className="gradient-text">AI Project</span></h1>
            <p className="page-description">
              Have questions about AI features for your website? Need a free audit of your current site?
              Fill out the form or reach out directly, We'll get back to you within 24 hours with
              practical, jargon-free recommendations.
            </p>
          </div>

          {/* Contact Info + Form */}
          <div className="contact-wrapper" id="contact-form-section">
            <div className="contact-info">
              {contactInfo.map((info, i) => (
                <div className="contact-info-card" key={i}>
                  <div className="contact-info-icon">
                    <i className={`fas ${info.icon}`}></i>
                  </div>
                  <h4>{info.title}</h4>
                  <span className="contact-info-detail">{info.detail}</span>
                  {info.href ? (
                    <a href={info.href}>{info.value}</a>
                  ) : info.type === 'email' || info.type === 'business_email' ? (
                    <a
                      href={`mailto:${info.value}`}
                      dangerouslySetInnerHTML={{
                        __html: encodeEmail(info.value.split('@')[0], info.value.split('@')[1]).label,
                      }}
                    />
                  ) : (
                    <p>{info.value}</p>
                  )}
                </div>
              ))}
            </div>

            <div className="contact-form-wrapper">
              <ContactForm />
            </div>
          </div>


          {/* FAQ */}
          <div className="contact-faq">
            <div className="section-header">
              <span className="section-badge">FAQ</span>
              <h2 className="section-title">Frequently Asked <span className="gradient-text">Questions</span></h2>
              <p className="section-description">
                Common questions about getting in touch, our process, and what to expect.
              </p>
            </div>
            <div className="faq-list">
              {FAQS.map((faq, i) => (
                <div className="faq-item" key={i}>
                                    <button className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                    <span>{faq.question}</span>
                    <i className={`fas fa-chevron-down faq-chevron ${openFaq === i ? 'active' : ''}`}></i>
                  </button>
                  {openFaq === i && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

                                                  {/* Bottom CTA */}
          <div className="cta-section">
            <div className="cta-wrapper">
              <div className="cta-content">
                <span className="section-badge">Get Started</span>
                <h2 className="cta-title">Ready to Add <span className="gradient-text">AI</span> to Your Business?</h2>
                <p className="cta-description">
                  Get a free AI audit of your current website. We'll identify quick wins and recommend the
                  perfect AI features for your business.
                </p>
                <div className="cta-buttons">
                  <a href="#contact-form-section" className="btn btn-primary btn-lg">
                    Contact Now <i className="fas fa-paper-plane"></i>
                  </a>
                  <Link to="/services" className="btn btn-outline btn-lg">
                    Explore Services <i className="fas fa-th-large"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

